import { c as _c } from "react/compiler-runtime";
import { EntityUtils } from '@record-it-npm/synchro-client';
import React, { ComponentProps, FunctionComponent, useMemo } from 'react';
import { prepareProps } from 'record-it-components/utils/propUtils';
import { PropsWithoutChildren } from 'record-it-components/utils/utilityTypes';
import { ConstructionSite } from '../../../classes/entities/ConstructionSite/constructionSiteTypes';
import { ConstructionSiteUtils } from '../../../classes/entities/ConstructionSite/ConstructionSiteUtils';
import { ConstructionSiteToSelectListItem } from '../../constructionSite/ConstructionSiteToSelectListItem/ConstructionSiteToSelectListItem';
import { useConstructionSiteSelectedHandler } from './useConstructionSiteSelectedHandler';
export type CreateWorkTimeEntrySelectConstructionSitePageSearchContentProps = PropsWithoutChildren<ComponentProps<'div'>> & {
  constructionSites: Array<ConstructionSite>;
  searchText: string;
};
export const CreateWorkTimeEntrySelectConstructionSitePageSearchContent: FunctionComponent<CreateWorkTimeEntrySelectConstructionSitePageSearchContentProps> = React.memo(props => {
  const $ = _c(19);
  let t0;
  if ($[0] !== props) {
    t0 = prepareProps({
      props,
      ignoreChildren: true
    });
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let constructionSites;
  let remainingProps;
  let searchText;
  if ($[2] !== t0) {
    ({
      constructionSites,
      searchText,
      ...remainingProps
    } = t0);
    $[2] = t0;
    $[3] = constructionSites;
    $[4] = remainingProps;
    $[5] = searchText;
  } else {
    constructionSites = $[3];
    remainingProps = $[4];
    searchText = $[5];
  }
  const {
    handleConstructionSiteSelected
  } = useConstructionSiteSelectedHandler();
  let t1;
  bb0: {
    if (!searchText) {
      t1 = constructionSites;
      break bb0;
    }
    let t2;
    if ($[6] !== constructionSites || $[7] !== searchText) {
      let t3;
      if ($[9] !== searchText) {
        t3 = constructionSite => ConstructionSiteUtils.containsSearchText(constructionSite, searchText);
        $[9] = searchText;
        $[10] = t3;
      } else {
        t3 = $[10];
      }
      t2 = constructionSites.filter(t3);
      $[6] = constructionSites;
      $[7] = searchText;
      $[8] = t2;
    } else {
      t2 = $[8];
    }
    t1 = t2;
  }
  const foundConstructionSites = t1;
  let t2;
  if ($[11] !== foundConstructionSites || $[12] !== handleConstructionSiteSelected) {
    let t3;
    if ($[14] !== handleConstructionSiteSelected) {
      t3 = constructionSite_0 => <ConstructionSiteToSelectListItem key={EntityUtils.getTrackingKey(constructionSite_0)} constructionSite={constructionSite_0} onConstructionSiteSelected={handleConstructionSiteSelected} data-testid="CreateWorkTimeEntrySelectConstructionSitePage.ConstructionSiteListItem" />;
      $[14] = handleConstructionSiteSelected;
      $[15] = t3;
    } else {
      t3 = $[15];
    }
    t2 = foundConstructionSites.map(t3);
    $[11] = foundConstructionSites;
    $[12] = handleConstructionSiteSelected;
    $[13] = t2;
  } else {
    t2 = $[13];
  }
  let t3;
  if ($[16] !== remainingProps || $[17] !== t2) {
    t3 = <div {...remainingProps}>{t2}</div>;
    $[16] = remainingProps;
    $[17] = t2;
    $[18] = t3;
  } else {
    t3 = $[18];
  }
  return t3;
});